export const addBasicBoardModalInitValue = {
  data: {
    name: '',
    date: '',
    selectedAttendanceType: '',
    selectedAttendanceTypeOption: null,
    attendanceTypeOptions: [],
    place: '',
    onlineAccess: '',
    comments: '',
    files: [],
    actionType: '',
    selectedStatus: '',
    selectedStatusOption: null,
    statusOptions: [],
    selectedVisibility: '',
    selectedVisibilityOption: null,
    visibilityOptions: [],
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeName(): void {},
    handleChangeDate(): void {},
    handleChangeAttendanceType(): void {},
    handleChangePlace(): void {},
    handleChangeOnlineAccess(): void {},
    handleChangeComments(): void {},
    handleChangeFiles(): void {},
    handleRemoveFile(): void {},
    handleChangeStatus(): void {},
    handleChangeVisibility(): void {},
    handleSaveBasicBoard(): void {},
  },
};
